import { render, staticRenderFns } from "./HasCollectiveWaterHeater.vue?vue&type=template&id=1f362db2&"
import script from "./HasCollectiveWaterHeater.vue?vue&type=script&lang=ts&"
export * from "./HasCollectiveWaterHeater.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports